module.exports = __webpack_public_path__ + "static/media/hdfc_ergo_ic_logo_card.f98e9a4f.svg";